<template>
  <div>
    <el-row style="margin-top: 20px; padding-left: 5px">
      <el-col :sm="20">
        <div style="display: inline-block; margin-right: 10px">
          <strong style="font-size: 13px">{{ $t('select.shop') }}</strong><br>
          <el-select size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected" filterable>
            <el-option-group :label="$t('shop.added')">
              <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group :label="$t('shop.managed')">
              <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        &nbsp;&nbsp;
        <div style="display: inline-block; margin-right: 10px">
          <strong style="font-size: 13px">Chọn năm</strong><br>
          <el-date-picker
            v-model="year"
            size="small"
            type="year"
            :placeholder="$t('input.select_time')">
          </el-date-picker>
        </div>
      </el-col>
      <el-col :sm="4" class="text-right">
      </el-col>
    </el-row>

    <div style="margin-top: 30px">
      <el-table :data="data">
        <el-table-column :label="$t('base.month')" header-align="center" width="100px">
          <template slot-scope="scope">
            Tháng {{ scope.row.month }}
          </template>
        </el-table-column>
        <el-table-column label="Năm" header-align="center" width="100px">
          <template slot-scope="scope">
            {{ scope.row.year }}
          </template>
        </el-table-column>
        <el-table-column label="File kế hoạch" prop="file_id" header-align="center" width="280px">
          <template slot-scope="scope">
            <el-select size="mini" value="" v-model="scope.row.file_id" :placeholder="$t('base.select_plan_file')"
                       filterable
                       @change="m__on_change_file(scope.row)">
              <el-option v-for="file of agency_files" :key="file.id" :value="file.id"
                         :label="file.filename"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Kế hoạch" header-align="center" style="border-left: 2px solid">
          <el-table-column label="GMV" prop="target_gmv" width="120px" sortable="custom" style="border-left: 2px solid">
            <template slot-scope="scope">{{ scope.row.target_gmv | format_currency }}</template>
          </el-table-column>
          <el-table-column label="GMV Ads" prop="target_gmv" width="120px" sortable="custom"
                           style="border-left: 2px solid">
            <template slot-scope="scope">{{ scope.row.target_gmv_ads | format_currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" prop="target_cost" width="120px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.target_cost | format_currency }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Thực tế" header-align="center">
          <el-table-column label="GMV" sortable="custom" width="120px" prop="current_gmv">
            <template slot-scope="scope">{{ scope.row.current_gmv | format_currency }}</template>
          </el-table-column>
          <el-table-column label="GMV Ads" sortable="custom" width="120px" prop="current_gmv_ads">
            <template slot-scope="scope">{{ scope.row.current_gmv_ads | format_currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" sortable="custom" width="120px" prop="current_cost">
            <template slot-scope="scope">{{ scope.row.current_cost | format_currency }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Tỉ lệ hoàn thành GMV" header-align="center" sortable="custom" width="120px"
                         prop="remaining_percent">
          <template slot-scope="scope">{{ scope.row.remaining_percent }} %</template>
        </el-table-column>
        <el-table-column label="Tỉ lệ hoàn thành GMV Ads" header-align="center" sortable="custom" width="120px"
                         prop="remaining_percent">
          <template slot-scope="scope">{{ scope.row.remaining_percent_ads }} %</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
//import dayjs from 'dayjs'

export default {
  props: {
    shop_list: null,
    send_request_list: null
  },

  data() {
    return {
      year: new Date(),
      shopee_shop: {
        loading: false,
        list: [],
        selected: ''
      },
      loading: {
        get_data: false
      },
      agency_files: [],
      seller: null,
      data: [],
      order_type: 'confirmed'
    }
  },

  async beforeMount() {
    this.shopee_shop.list = this.clone(this.shop_list)

    const shop_default = this.shopee_shop.list.length === 1
      ? this.shopee_shop.list[0]
      : this.$route.query.shop_id ? this.shopee_shop.list.find(i => i.shop_id === this.$route.query.shop_id) : this.shopee_shop.list.find(i => !i.is_sub_account && i.extra_data && i.extra_data.default)
    if (shop_default) {
      this.shopee_shop.selected = shop_default._id
      this.ntf_s(`Chọn cửa hàng mặc định: ${shop_default.username}`)
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  methods: {
    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)

            await this.m__get_agency_file()
            await this.m__generate_data()
          }
        }

      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      }
    },

    async m__get_agency_file() {
      const mipeeUserIds = [this.$store.state.userInfo.username, ...this.send_request_list.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds
        }
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))
    },

    m__on_change_file(row) {
      const agency_file = this.agency_files.find(i => i.id === row.file_id)
      if (agency_file) {
        row.target_gmv = agency_file.expectedGmv
        row.target_gmv_ads = agency_file.expectedGmvAds
        row.target_cost = agency_file.expectedCost

        row.remaining_cost = row.target_cost - row.current_cost
        row.remaining_gmv = row.target_gmv - row.current_gmv
        row.remaining_plan_gmv = this.dayjs().month() === this.month ? Math.floor(row.current_gmv / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
        row.remaining_gmv_ads = row.target_gmv_ads - row.current_gmv_ads
        row.remaining_plan_gmv_ads = this.dayjs().month() === this.month ? Math.floor(row.current_gmv_ads / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
        row.remaining_percent = row.target_gmv > 0 ? +(row.current_gmv * 100 / row.target_gmv).toFixed(2) : 0
        row.remaining_percent_ads = row.target_gmv_ads > 0 ? +(row.current_gmv_ads * 100 / row.target_gmv_ads).toFixed(2) : 0

        if (row.remaining_gmv > 0) {
          if (this.dayjs().month() === this.month) {
            const remaining_day = this.dayjs().endOf('month').date() - this.dayjs().date() + 1
            row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
          } else if (this.dayjs().month() > this.month) {
            const remaining_day = this.dayjs().endOf('month').date()
            row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
          }
        }

        this.$http.post(this.API.URL_API_SRV_1 + '/agency_file/shop', {}, {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            shopId: row._id,
            month: this.month,
            year: this.year,
            agencyFileId: row.file_id
          }
        })
          .catch(console.error)
      }
    },

    async m__generate_data() {
      this.loading.get_data = true

      try {
        for (let i = 0; i < 12; i++) {
          const agency_file_shop = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/shop', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              shopId: this.shopee_shop.selected,
              month: i,
              year: this.dayjs(this.year).year()
            }
          })

          const row = {}

          row.month = i + 1
          row.year = this.dayjs(this.year).year()
          row.file_id = agency_file_shop.body && agency_file_shop.body.agencyFileId && this.agency_files.find(i => i.id === agency_file_shop.body.agencyFileId) ? agency_file_shop.body.agencyFileId : ''
          if (!row.file_id && this.agency_files.filter(i => i.shopId === this.shopee_shop.selected && i.expectedMonth === row.month - 1 && i.expectedYear === row.year).length) {
            row.file_id = this.agency_files.filter(i => i.shopId === this.shopee_shop.selected && i.expectedMonth === row.month - 1 && i.expectedYear === row.year)[0].id
          }

          const agency_file = this.agency_files.find(i => i.id === row.file_id)
          if (agency_file) {
            row.target_gmv = agency_file.expectedGmv
            row.target_gmv_ads = agency_file.expectedGmvAds
            row.target_cost = agency_file.expectedCost
          }

          const start_time = this.dayjs([this.dayjs(this.year).year(), i]).startOf('month')
          const end_time = this.dayjs([this.dayjs(this.year).year(), i]).endOf('month')
          const end_time_clone = end_time.isSameOrAfter(this.dayjs(), 'd') ? this.dayjs().startOf('d') : end_time.clone().add(1, 'd').startOf('d')

          if (start_time.isAfter(this.dayjs(), 'month')) {
            this.data.push(row)
            continue
          }

          const metrics_resp = await this.seller.dashboard__key_metrics(start_time.unix(), end_time_clone.unix(), 'month')
          if (metrics_resp && metrics_resp.result) {
            const key_metrics = metrics_resp.result

            let place_gmv_key = 'place_gmv'
            if (this.order_type) place_gmv_key = place_gmv_key.replace(/(placed|place)/, this.order_type)
            row.current_gmv = key_metrics[place_gmv_key].value
          }

          const resp = await this.seller.marketing_homepage_report_by_time(start_time, end_time, '[0,1,2,3,4,5,8]')
          if (resp && resp.data && resp.data.data) {
            const metrics = {}
            for (const item of resp.data.data.homepage_report) {
              for (const key of Object.keys(item)) {
                if (metrics[key]) {
                  metrics[key] += +item[key]
                } else {
                  metrics[key] = +item[key]
                }
              }
            }

            row.current_gmv_ads = metrics.broad_gmv
            row.current_cost = metrics.cost
          }

          row.remaining_cost = row.target_cost - row.current_cost
          row.remaining_gmv = row.target_gmv - row.current_gmv
          // console.log(row.current_gmv)
          // console.log(this.dayjs().date())
          // console.log(this.dayjs().endOf('month').date())
          row.remaining_plan_gmv = this.dayjs().month() === this.month ? Math.floor(row.current_gmv / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
          // console.log(row.remaining_plan_gmv)
          row.remaining_gmv_ads = row.target_gmv_ads - row.current_gmv_ads
          row.remaining_plan_gmv_ads = this.dayjs().month() === this.month ? Math.floor(row.current_gmv_ads / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
          row.remaining_percent = row.target_gmv > 0 ? +(row.current_gmv * 100 / row.target_gmv).toFixed(2) : 0
          row.remaining_percent_ads = row.target_gmv_ads > 0 ? +(row.current_gmv_ads * 100 / row.target_gmv_ads).toFixed(2) : 0

          if (row.remaining_gmv > 0) {
            if (this.dayjs().month() === this.month) {
              const remaining_day = this.dayjs().endOf('month').date() - this.dayjs().date() + 1
              row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
            } else if (this.dayjs().month() > this.month) {
              const remaining_day = this.dayjs().endOf('month').date()
              row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
            }
          }

          this.data.push(row)
        }

        console.log(this.data)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/agency/plan_year.vue